/**
 * Décision 343 — la note de l'accueil pour la chargée : ce qui se lit, et ce
 * qui s'écrit. Rien de médical.
 */
import { z } from 'zod';
import { NOTE_CHARGEE_MAX } from '../rules/note-chargee.js';
const texteDeNote = z
    .string()
    .trim()
    .max(NOTE_CHARGEE_MAX, `La note tient en ${String(NOTE_CHARGEE_MAX)} caractères au plus.`);
export const schemaNoteChargee = z.object({
    texte: z.string(),
    /** Le nom de l'accueil qui l'a écrite ou modifiée en dernier. */
    auteur: z.string().nullable(),
    ecriteLe: z.iso.datetime(),
});
/** Écrire ou modifier la note ; un texte vide la retire. */
export const schemaSaisieNoteChargee = z.object({ texte: texteDeNote }).strict();
/** La note d'une fiche, pour qui peut la lire, et si ce lecteur peut encore la modifier. */
export const schemaNoteChargeeDeLaFiche = z.object({
    note: schemaNoteChargee.nullable(),
    modifiable: z.boolean(),
});
/** À l'enrôlement : facultative, vide = aucune. */
export const champNoteChargeeALEnrolement = texteDeNote.nullish();
//# sourceMappingURL=note-chargee.js.map